module.exports = __webpack_public_path__ + "img/patrick-eyes.4d7012f7.png";